module.exports = __webpack_public_path__ + "media/images/store-67734efc.svg";